import React, { useEffect, useRef } from 'react'


const SleepOverlay = () => {
    const ellipseRef = useRef<SVGEllipseElement>(null);
    const svgRef = useRef<SVGSVGElement>(null);
    const brightnessRef = useRef<HTMLDivElement>(null);
    const rxRef = useRef(50);

    useEffect(() => {
        let frame: number;
        let maxRy = 32;
        let minRy = 2;
        let t = 0;
        let duration = getRandomInt(40, 180); // frames for open/close
        let delayFrames = getRandomInt(20, 60); // delay frames
        let phase = 'delayOpen'; // 'delayOpen', 'opening', 'delayClose', 'closing'
        let delayCounter = 0;

        function getRandomInt(min: number, max: number) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        const updateMaxRxRy = () => {
            if (svgRef.current) {
                // Use 40% of SVG height for max opening
                const height = svgRef.current.viewBox.baseVal.height || 100;
                const width = svgRef.current.viewBox.baseVal.width || 100;
                maxRy = height * 0.4;
                minRy = Math.max(0, height * 0.001);
                rxRef.current = width * 0.45; // 50% of width
                if (ellipseRef.current) {
                    ellipseRef.current.setAttribute('rx', rxRef.current.toString());
                }
            }
        };
        updateMaxRxRy();
        window.addEventListener('resize', updateMaxRxRy);

        const animate = () => {
            if (phase === 'delayOpen') {
                delayCounter++;
                if (delayCounter >= delayFrames) {
                    delayCounter = 0;
                    phase = 'opening';
                }
            } else if (phase === 'opening') {
                t++;
                if (t >= duration) {
                    t = duration;
                    phase = 'delayClose';
                }
            } else if (phase === 'delayClose') {
                delayCounter++;
                if (delayCounter >= delayFrames) {
                    delayCounter = 0;
                    phase = 'closing';
                }
            } else if (phase === 'closing') {
                t--;
                if (t <= 0) {
                    t = 0;
                    // Randomize duration and delayFrames for next cycle
                    duration = getRandomInt(90, 180);
                    delayFrames = getRandomInt(20, 60);
                    phase = 'delayOpen';
                }
            }
            // easeInOut using sine
            const progress = t / duration;
            const ease = 0.5 - 0.5 * Math.cos(Math.PI * progress); // 0 to 1 to 0
            const ry = minRy + (maxRy - minRy) * ease;
            if (ellipseRef.current) {
                ellipseRef.current.setAttribute('ry', ry.toString());
                ellipseRef.current.setAttribute('rx', rxRef.current.toString());
            }
            if (brightnessRef.current) {
                    // Brightness: 0.3 when closed (ease=0), 1.3 when open (ease=1)
                    const brightness = ease * 1 + 0.3;
                    // Blur: 10px when closed (ease=0), 0px when open (ease=1)
                    const blur = 20 - 18 * ease;
                    brightnessRef.current.style.backdropFilter = `brightness(${brightness}) blur(${blur}px)`;
            }
            frame = requestAnimationFrame(animate);
        };
        frame = requestAnimationFrame(animate);
        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener('resize', updateMaxRxRy);
        };
    }, []);

    return (
        <div className="absolute inset-0 w-full h-full pointer-events-none z-[10] flex items-center justify-center">
            <div 
                ref={brightnessRef} 
                className="absolute inset-0 w-full h-full" 
                style={{ backdropFilter: 'brightness(0)' }}
            />
                <svg
                    ref={svgRef}
                    className="w-full h-full"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        filter:
                            (typeof window !== 'undefined' && svgRef.current &&
                                (svgRef.current.clientWidth < 501 || svgRef.current.clientHeight < 501))
                                ? 'blur(4px)'
                                : 'blur(16px)'
                    }}
                >
                <defs>
                    <mask id="ellipse-mask">
                        <rect x="0" y="0" width="100" height="100" fill="white" />
                        <ellipse ref={ellipseRef} cx="50" cy="50" rx={rxRef.current} ry="32" fill="black" />
                    </mask>
                </defs>
                <rect x="0" y="0" width="100" height="100" fill="black" mask="url(#ellipse-mask)" />
                </svg>
            <div className="absolute inset-0 w-full h-full z-[11] pointer-events-none">
                <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" style={{ position: 'absolute', top: 0, left: 0 }}>
                    <defs>
                        <mask id="border-mask">
                            <rect x="0" y="0" width="100" height="100" fill="white" />
                            <rect x="2.5" y="5" width="95" height="90" fill="black" />
                        </mask>
                    </defs>
                    <rect x="0" y="0" width="100" height="100" fill="black" mask="url(#border-mask)" />
                </svg>
            </div>
        </div>
    )
}

export default SleepOverlay